<template>
  <section id="test-vocacional">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 mx-auto d-flex justify-content-center align-items-center">
          <div class="content-wrapper my-5 bg-white rounded p-4 pb-5 w-100 position-relative">
            <!-- body -->
            <div class="row mt-5 row mt-0 mt-md-4">
              <div class="col-lg-5">
                <p class="mb-2">El área de estudio con más afinidad a ti es:</p>
                <h3 class="text-size-titulo1 text-primary mt-0 pb-3 mb-3 deco-line deco-line--bottom">{{questionStore.bestResult.area.toUpperCase()}}</h3>
                <p>{{questionStore.bestResult.frase}}</p>
                <a target="_blank" :href="url" class="btn btn-primary mt-5 font-weight-normal w-100">Descubre los títulos de este área</a>
                <a @click="questionStore.changeStepWithReset('start')" class="btn btn-outline-primary mt-3 font-weight-normal w-100"> Volver a inicio </a>
              </div>
              <div class="col-lg-7 mt-5 mt-lg-0">
                <highcharts :options="chartOptions"></highcharts>
                <a @click="questionStore.changeStepWithReset('start')" class="btn btn-outline-primary mt-3 font-weight-normal w-100  d-md-none mt-3"> Volver a inicio </a>
              </div>
            </div>
            <!-- ./end body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {useQuestionStore} from "@/stores/question.js";
import {computed, onMounted, ref} from "vue";

const questionStore = useQuestionStore();

const chartOptions = ref({
  colors:['#edab00'],
  title: {
    text: 'Esta es tu Orientación profesional'
  },
  credits: {
    enabled: false
  },
  chart: {
    polar: true,
    type: 'line',
    style: {
      fontFamily: 'Open Sans,sans-serif'
    }
  },
  tooltip: {
    enabled: true,
    formatter: function() {
      return `<b>{questionStore.keyFilterArea}</b>`;
    }
  },
  xAxis: {
    labels: {
      enabled: true
    },
    categories: [],
      tickmarkPlacement: 'on',
      lineWidth: 0
  },

  yAxis: {
    labels: {
      enabled: false
    },
    gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0
  },
  plotOptions: {
    series: {
      events: {
        legendItemClick: function () {
          return false;
        }
      }
    },
    candlestick: {
      lineColor: '#edab00'
    }
  },
  series: [{
    name: '',
    data: []
  }]
})

onMounted(() => {
  document.documentElement.scrollTop = 100;
  chartOptions.value.xAxis.categories = questionStore.areas;
  chartOptions.value.series = {
    name: 'Afinidad',
    data: questionStore.questionsResult
  }
})

const url = computed(() => {
  return `https://www.ucam.edu/estudios?f=Grado&f=${questionStore.keyFilterArea}`
})
</script>

<style scoped>

</style>
